// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.6
//   protoc               unknown
// source: photon/imessage/v1/attachment_service.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import type { CallContext, CallOptions } from "nice-grpc-common";
import { AttachmentInfo, Companion, CompanionInfo } from "./attachment_types.js";

export const protobufPackage = "photon.imessage.v1";

export interface GetAttachmentInfoRequest {
  attachmentGuid: string;
}

export interface GetAttachmentInfoResponse {
  attachment: AttachmentInfo | undefined;
}

export interface UploadAttachmentRequest {
  /**
   * Plain file name. Server normalizes: strips path components, replaces
   * path separators (`/`, `\`) with `_`, drops control characters,
   * truncates to a fixed UTF-8 byte budget while preserving the
   * extension, and falls back to `attachment` if the result is empty.
   */
  fileName: string;
  data: Uint8Array;
  companion?: Companion | undefined;
}

export interface UploadAttachmentResponse {
  attachment:
    | AttachmentInfo
    | undefined;
  /** Set iff the request carried a companion. */
  companion?: CompanionInfo | undefined;
}

export interface DownloadAttachmentRequest {
  attachmentGuid: string;
}

export interface DownloadHeader {
  attachment: AttachmentInfo | undefined;
  companion?: CompanionInfo | undefined;
}

/**
 * Server-stream frame contract:
 *
 *   Frame 0       exactly one `header`
 *   Frames 1..N   `primary_chunk*`
 *   Frames N+1..M `companion_chunk*` emitted only when a companion exists
 *   Close         gRPC half-close, no sentinel frame
 */
export interface DownloadAttachmentResponse {
  header?: DownloadHeader | undefined;
  primaryChunk?: Uint8Array | undefined;
  companionChunk?: Uint8Array | undefined;
}

function createBaseGetAttachmentInfoRequest(): GetAttachmentInfoRequest {
  return { attachmentGuid: "" };
}

export const GetAttachmentInfoRequest: MessageFns<GetAttachmentInfoRequest> = {
  encode(message: GetAttachmentInfoRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.attachmentGuid !== "") {
      writer.uint32(10).string(message.attachmentGuid);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetAttachmentInfoRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetAttachmentInfoRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.attachmentGuid = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetAttachmentInfoRequest {
    return {
      attachmentGuid: isSet(object.attachmentGuid)
        ? globalThis.String(object.attachmentGuid)
        : isSet(object.attachment_guid)
        ? globalThis.String(object.attachment_guid)
        : "",
    };
  },

  toJSON(message: GetAttachmentInfoRequest): unknown {
    const obj: any = {};
    if (message.attachmentGuid !== "") {
      obj.attachmentGuid = message.attachmentGuid;
    }
    return obj;
  },

  create(base?: DeepPartial<GetAttachmentInfoRequest>): GetAttachmentInfoRequest {
    return GetAttachmentInfoRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetAttachmentInfoRequest>): GetAttachmentInfoRequest {
    const message = createBaseGetAttachmentInfoRequest();
    message.attachmentGuid = object.attachmentGuid ?? "";
    return message;
  },
};

function createBaseGetAttachmentInfoResponse(): GetAttachmentInfoResponse {
  return { attachment: undefined };
}

export const GetAttachmentInfoResponse: MessageFns<GetAttachmentInfoResponse> = {
  encode(message: GetAttachmentInfoResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.attachment !== undefined) {
      AttachmentInfo.encode(message.attachment, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetAttachmentInfoResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetAttachmentInfoResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.attachment = AttachmentInfo.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetAttachmentInfoResponse {
    return { attachment: isSet(object.attachment) ? AttachmentInfo.fromJSON(object.attachment) : undefined };
  },

  toJSON(message: GetAttachmentInfoResponse): unknown {
    const obj: any = {};
    if (message.attachment !== undefined) {
      obj.attachment = AttachmentInfo.toJSON(message.attachment);
    }
    return obj;
  },

  create(base?: DeepPartial<GetAttachmentInfoResponse>): GetAttachmentInfoResponse {
    return GetAttachmentInfoResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetAttachmentInfoResponse>): GetAttachmentInfoResponse {
    const message = createBaseGetAttachmentInfoResponse();
    message.attachment = (object.attachment !== undefined && object.attachment !== null)
      ? AttachmentInfo.fromPartial(object.attachment)
      : undefined;
    return message;
  },
};

function createBaseUploadAttachmentRequest(): UploadAttachmentRequest {
  return { fileName: "", data: new Uint8Array(0), companion: undefined };
}

export const UploadAttachmentRequest: MessageFns<UploadAttachmentRequest> = {
  encode(message: UploadAttachmentRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.fileName !== "") {
      writer.uint32(10).string(message.fileName);
    }
    if (message.data.length !== 0) {
      writer.uint32(18).bytes(message.data);
    }
    if (message.companion !== undefined) {
      Companion.encode(message.companion, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UploadAttachmentRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUploadAttachmentRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fileName = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.data = reader.bytes();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.companion = Companion.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UploadAttachmentRequest {
    return {
      fileName: isSet(object.fileName)
        ? globalThis.String(object.fileName)
        : isSet(object.file_name)
        ? globalThis.String(object.file_name)
        : "",
      data: isSet(object.data) ? bytesFromBase64(object.data) : new Uint8Array(0),
      companion: isSet(object.companion) ? Companion.fromJSON(object.companion) : undefined,
    };
  },

  toJSON(message: UploadAttachmentRequest): unknown {
    const obj: any = {};
    if (message.fileName !== "") {
      obj.fileName = message.fileName;
    }
    if (message.data.length !== 0) {
      obj.data = base64FromBytes(message.data);
    }
    if (message.companion !== undefined) {
      obj.companion = Companion.toJSON(message.companion);
    }
    return obj;
  },

  create(base?: DeepPartial<UploadAttachmentRequest>): UploadAttachmentRequest {
    return UploadAttachmentRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<UploadAttachmentRequest>): UploadAttachmentRequest {
    const message = createBaseUploadAttachmentRequest();
    message.fileName = object.fileName ?? "";
    message.data = object.data ?? new Uint8Array(0);
    message.companion = (object.companion !== undefined && object.companion !== null)
      ? Companion.fromPartial(object.companion)
      : undefined;
    return message;
  },
};

function createBaseUploadAttachmentResponse(): UploadAttachmentResponse {
  return { attachment: undefined, companion: undefined };
}

export const UploadAttachmentResponse: MessageFns<UploadAttachmentResponse> = {
  encode(message: UploadAttachmentResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.attachment !== undefined) {
      AttachmentInfo.encode(message.attachment, writer.uint32(10).fork()).join();
    }
    if (message.companion !== undefined) {
      CompanionInfo.encode(message.companion, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UploadAttachmentResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUploadAttachmentResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.attachment = AttachmentInfo.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.companion = CompanionInfo.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UploadAttachmentResponse {
    return {
      attachment: isSet(object.attachment) ? AttachmentInfo.fromJSON(object.attachment) : undefined,
      companion: isSet(object.companion) ? CompanionInfo.fromJSON(object.companion) : undefined,
    };
  },

  toJSON(message: UploadAttachmentResponse): unknown {
    const obj: any = {};
    if (message.attachment !== undefined) {
      obj.attachment = AttachmentInfo.toJSON(message.attachment);
    }
    if (message.companion !== undefined) {
      obj.companion = CompanionInfo.toJSON(message.companion);
    }
    return obj;
  },

  create(base?: DeepPartial<UploadAttachmentResponse>): UploadAttachmentResponse {
    return UploadAttachmentResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<UploadAttachmentResponse>): UploadAttachmentResponse {
    const message = createBaseUploadAttachmentResponse();
    message.attachment = (object.attachment !== undefined && object.attachment !== null)
      ? AttachmentInfo.fromPartial(object.attachment)
      : undefined;
    message.companion = (object.companion !== undefined && object.companion !== null)
      ? CompanionInfo.fromPartial(object.companion)
      : undefined;
    return message;
  },
};

function createBaseDownloadAttachmentRequest(): DownloadAttachmentRequest {
  return { attachmentGuid: "" };
}

export const DownloadAttachmentRequest: MessageFns<DownloadAttachmentRequest> = {
  encode(message: DownloadAttachmentRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.attachmentGuid !== "") {
      writer.uint32(10).string(message.attachmentGuid);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DownloadAttachmentRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDownloadAttachmentRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.attachmentGuid = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DownloadAttachmentRequest {
    return {
      attachmentGuid: isSet(object.attachmentGuid)
        ? globalThis.String(object.attachmentGuid)
        : isSet(object.attachment_guid)
        ? globalThis.String(object.attachment_guid)
        : "",
    };
  },

  toJSON(message: DownloadAttachmentRequest): unknown {
    const obj: any = {};
    if (message.attachmentGuid !== "") {
      obj.attachmentGuid = message.attachmentGuid;
    }
    return obj;
  },

  create(base?: DeepPartial<DownloadAttachmentRequest>): DownloadAttachmentRequest {
    return DownloadAttachmentRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<DownloadAttachmentRequest>): DownloadAttachmentRequest {
    const message = createBaseDownloadAttachmentRequest();
    message.attachmentGuid = object.attachmentGuid ?? "";
    return message;
  },
};

function createBaseDownloadHeader(): DownloadHeader {
  return { attachment: undefined, companion: undefined };
}

export const DownloadHeader: MessageFns<DownloadHeader> = {
  encode(message: DownloadHeader, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.attachment !== undefined) {
      AttachmentInfo.encode(message.attachment, writer.uint32(10).fork()).join();
    }
    if (message.companion !== undefined) {
      CompanionInfo.encode(message.companion, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DownloadHeader {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDownloadHeader();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.attachment = AttachmentInfo.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.companion = CompanionInfo.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DownloadHeader {
    return {
      attachment: isSet(object.attachment) ? AttachmentInfo.fromJSON(object.attachment) : undefined,
      companion: isSet(object.companion) ? CompanionInfo.fromJSON(object.companion) : undefined,
    };
  },

  toJSON(message: DownloadHeader): unknown {
    const obj: any = {};
    if (message.attachment !== undefined) {
      obj.attachment = AttachmentInfo.toJSON(message.attachment);
    }
    if (message.companion !== undefined) {
      obj.companion = CompanionInfo.toJSON(message.companion);
    }
    return obj;
  },

  create(base?: DeepPartial<DownloadHeader>): DownloadHeader {
    return DownloadHeader.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<DownloadHeader>): DownloadHeader {
    const message = createBaseDownloadHeader();
    message.attachment = (object.attachment !== undefined && object.attachment !== null)
      ? AttachmentInfo.fromPartial(object.attachment)
      : undefined;
    message.companion = (object.companion !== undefined && object.companion !== null)
      ? CompanionInfo.fromPartial(object.companion)
      : undefined;
    return message;
  },
};

function createBaseDownloadAttachmentResponse(): DownloadAttachmentResponse {
  return { header: undefined, primaryChunk: undefined, companionChunk: undefined };
}

export const DownloadAttachmentResponse: MessageFns<DownloadAttachmentResponse> = {
  encode(message: DownloadAttachmentResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      DownloadHeader.encode(message.header, writer.uint32(10).fork()).join();
    }
    if (message.primaryChunk !== undefined) {
      writer.uint32(18).bytes(message.primaryChunk);
    }
    if (message.companionChunk !== undefined) {
      writer.uint32(26).bytes(message.companionChunk);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DownloadAttachmentResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDownloadAttachmentResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = DownloadHeader.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.primaryChunk = reader.bytes();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.companionChunk = reader.bytes();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DownloadAttachmentResponse {
    return {
      header: isSet(object.header) ? DownloadHeader.fromJSON(object.header) : undefined,
      primaryChunk: isSet(object.primaryChunk)
        ? bytesFromBase64(object.primaryChunk)
        : isSet(object.primary_chunk)
        ? bytesFromBase64(object.primary_chunk)
        : undefined,
      companionChunk: isSet(object.companionChunk)
        ? bytesFromBase64(object.companionChunk)
        : isSet(object.companion_chunk)
        ? bytesFromBase64(object.companion_chunk)
        : undefined,
    };
  },

  toJSON(message: DownloadAttachmentResponse): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = DownloadHeader.toJSON(message.header);
    }
    if (message.primaryChunk !== undefined) {
      obj.primaryChunk = base64FromBytes(message.primaryChunk);
    }
    if (message.companionChunk !== undefined) {
      obj.companionChunk = base64FromBytes(message.companionChunk);
    }
    return obj;
  },

  create(base?: DeepPartial<DownloadAttachmentResponse>): DownloadAttachmentResponse {
    return DownloadAttachmentResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<DownloadAttachmentResponse>): DownloadAttachmentResponse {
    const message = createBaseDownloadAttachmentResponse();
    message.header = (object.header !== undefined && object.header !== null)
      ? DownloadHeader.fromPartial(object.header)
      : undefined;
    message.primaryChunk = object.primaryChunk ?? undefined;
    message.companionChunk = object.companionChunk ?? undefined;
    return message;
  },
};

/**
 * Attachment metadata reads, uploads, and downloads. All transfers are
 * end-to-end on this gRPC channel; no external blob store is involved.
 */
export type AttachmentServiceDefinition = typeof AttachmentServiceDefinition;
export const AttachmentServiceDefinition = {
  name: "AttachmentService",
  fullName: "photon.imessage.v1.AttachmentService",
  methods: {
    /** Metadata-only lookup. Cheap; never touches attachment bytes. */
    getAttachmentInfo: {
      name: "GetAttachmentInfo",
      requestType: GetAttachmentInfoRequest as typeof GetAttachmentInfoRequest,
      requestStream: false,
      responseType: GetAttachmentInfoResponse as typeof GetAttachmentInfoResponse,
      responseStream: false,
      options: {},
    },
    /**
     * Atomic upload of one primary file plus an optional sidecar. The
     * server persists both before responding; on failure neither is visible
     * to subsequent reads.
     */
    uploadAttachment: {
      name: "UploadAttachment",
      requestType: UploadAttachmentRequest as typeof UploadAttachmentRequest,
      requestStream: false,
      responseType: UploadAttachmentResponse as typeof UploadAttachmentResponse,
      responseStream: false,
      options: {},
    },
    /**
     * Server-streaming bytes. See `DownloadAttachmentResponse` for the
     * frame contract.
     */
    downloadAttachment: {
      name: "DownloadAttachment",
      requestType: DownloadAttachmentRequest as typeof DownloadAttachmentRequest,
      requestStream: false,
      responseType: DownloadAttachmentResponse as typeof DownloadAttachmentResponse,
      responseStream: true,
      options: {},
    },
  },
} as const;

export interface AttachmentServiceImplementation<CallContextExt = {}> {
  /** Metadata-only lookup. Cheap; never touches attachment bytes. */
  getAttachmentInfo(
    request: GetAttachmentInfoRequest,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<GetAttachmentInfoResponse>>;
  /**
   * Atomic upload of one primary file plus an optional sidecar. The
   * server persists both before responding; on failure neither is visible
   * to subsequent reads.
   */
  uploadAttachment(
    request: UploadAttachmentRequest,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<UploadAttachmentResponse>>;
  /**
   * Server-streaming bytes. See `DownloadAttachmentResponse` for the
   * frame contract.
   */
  downloadAttachment(
    request: DownloadAttachmentRequest,
    context: CallContext & CallContextExt,
  ): ServerStreamingMethodResult<DeepPartial<DownloadAttachmentResponse>>;
}

export interface AttachmentServiceClient<CallOptionsExt = {}> {
  /** Metadata-only lookup. Cheap; never touches attachment bytes. */
  getAttachmentInfo(
    request: DeepPartial<GetAttachmentInfoRequest>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<GetAttachmentInfoResponse>;
  /**
   * Atomic upload of one primary file plus an optional sidecar. The
   * server persists both before responding; on failure neither is visible
   * to subsequent reads.
   */
  uploadAttachment(
    request: DeepPartial<UploadAttachmentRequest>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<UploadAttachmentResponse>;
  /**
   * Server-streaming bytes. See `DownloadAttachmentResponse` for the
   * frame contract.
   */
  downloadAttachment(
    request: DeepPartial<DownloadAttachmentRequest>,
    options?: CallOptions & CallOptionsExt,
  ): AsyncIterable<DownloadAttachmentResponse>;
}

function bytesFromBase64(b64: string): Uint8Array {
  if ((globalThis as any).Buffer) {
    return Uint8Array.from((globalThis as any).Buffer.from(b64, "base64"));
  } else {
    const bin = globalThis.atob(b64);
    const arr = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; ++i) {
      arr[i] = bin.charCodeAt(i);
    }
    return arr;
  }
}

function base64FromBytes(arr: Uint8Array): string {
  if ((globalThis as any).Buffer) {
    return (globalThis as any).Buffer.from(arr).toString("base64");
  } else {
    const bin: string[] = [];
    arr.forEach((byte) => {
      bin.push(globalThis.String.fromCharCode(byte));
    });
    return globalThis.btoa(bin.join(""));
  }
}

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export type ServerStreamingMethodResult<Response> = { [Symbol.asyncIterator](): AsyncIterator<Response, void> };

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create(base?: DeepPartial<T>): T;
  fromPartial(object: DeepPartial<T>): T;
}
